export default "__VITE_PUBLIC_ASSET__8d26d038__"